export default __webpack_public_path__ + "static/image_03-98049631dc5bb3d2947e09f241dbfe0c.png";